import { useEffect, useMemo, useRef, useState } from "react";
import Skeleton from "../skeleton";
import { useCounters } from "./useFindListings";
import { usePath } from "@/contexts/path/path";
import css from "./.module.scss";
import { DEFAULT_CATEGORY } from "@/lib/path-resolver-middlewares/category";
import { appHistory } from "@/lib/app.history";
import AppLink from "@/components/new-resolver/app.ink";
import {
  trackCategoryChange,
  trackOpenSearch,
} from "@/lib/tracking/trackNavigationEvents";
import { useAppState } from "@/contexts/app/app.provider";

function Holder() {
  return (
    <Skeleton
      style={{
        padding: "0.3rem 0",
      }}
    >
      <Skeleton.Text
        style={{
          marginBottom: ".5rem",
          width: "12rem",
          height: "2.21rem",
          borderRadius: ".5rem",
        }}
      />
    </Skeleton>
  );
}
export function CountersButtonsHolder({}) {
  const { isMobile } = useAppState();

  return (
    <div className={css.holder}>
      <Holder />
      <Holder />
      <Holder />
      <Holder />
      {isMobile ? null : (
        <>
          <Holder />
          <Holder />
          <Holder />
          <Holder />
        </>
      )}
    </div>
  );
}

// eslint-disable-next-line react/prop-types
export function CountersButtons({ bottom = false, isExpand, onExpand } = {}) {
  const [cities, cityLoading] = useCounters();
  const { updateContext } = usePath();
  const { isMobile: mobile } = useAppState();
  const [isMobile, setIsMobile] = useState(mobile);
  useEffect(() => {
    // if (window.innerWidth < 700) setIsMobile(true);
    // else setIsMobile(false);
  }, []);
  const buttonsNumber = isMobile ? 3 : 6;
  const firstCities = useMemo(
    () => cities.slice(0, buttonsNumber),
    [isMobile, cities],
  );

  const handleExpand = () => {
    if (typeof onExpand === "function") {
      onExpand();
    }
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  if (cityLoading) {
    return <CountersButtonsHolder isMobile={mobile} />;
  }

  return (
    !!cities.length && (
      <div className={`${css.counter} ${bottom ? css.bottom : ""}`}>
        <div>
          {(bottom && isExpand ? cities : firstCities).map((ci) => (
            <AppLink
              className={css.btn}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                if (bottom) {
                  scrollToTop();
                }
                if (ci.__typename === "City")
                  return updateContext({
                    page: 0,
                    polygon: undefined,
                    listing: null,
                    city: { ...ci, id: ci.city_id },
                  });

                if (ci.__typename === "Direction") {
                  return updateContext({
                    direction: {
                      ...ci,
                      id: ci.direction_id,
                    },
                    page: 0,
                    polygon: undefined,
                    listing: null,
                  });
                }
                const { city, direction, ...district } = ci;
                return updateContext({
                  listing: null,
                  page: 0,
                  polygon: undefined,
                  district: {
                    ...district,
                    id: district.district_id,
                  },
                });
              }}
              key={ci.path}
              path={ci.path}
            >
              {ci.title}&nbsp;<span>({ci.count})</span>
            </AppLink>
          ))}
          {cities.length > buttonsNumber && !bottom ? (
            <CounterButton onClick={handleExpand}>المزيد</CounterButton>
          ) : null}
        </div>
      </div>
    )
  );
}

export default function CounterButton({ href, ...props }) {
  return <button type="button" className={css.btn} {...props} />;
}

export function CategoryList() {
  const {
    categories: sourceCategories = [],
    basePath,
    category,
    updateContext,
    listing,
    listingType,
  } = usePath();
  const categoriesListRef = useRef();
  const isDaily =
    basePath?.includes("/daily-rent") || basePath?.includes("الحجز-اليومي");

  const categories = useMemo(() => {
    if (
      basePath?.includes("/daily-rent") ||
      basePath?.includes("/الحجز-اليومي")
    )
      return sourceCategories.filter((t) => t.id && t.id > 100);
    return sourceCategories.filter((t) => t.id && t.id < 101);
  }, [sourceCategories, basePath]);
  const lastCatId = useRef();

  useEffect(() => {
    categoriesListRef.current?.addEventListener(
      "wheel",
      (event) => {
        event.preventDefault();
        categoriesListRef.current?.scrollBy({
          left: event.deltaY,
        });
      },
      { passive: false },
    );
  }, []);

  useEffect(() => {
    if (!category)
      return categoriesListRef.current?.children[0]?.scrollTo({ left: 0 });
    if (category?.id === lastCatId.current) return;
    const cat = categories?.find((c) => c.id === category?.id);
    categoriesListRef.current?.children[cat?.index || 0]?.scrollIntoView({
      block: "center",
      inline: "nearest",
    });

    //return () => clearTimeout(id);
  }, [category, categories]);
  return (
    <div className={css.category}>
      <button
        type="button"
        className={css.search}
        onClick={(event) => {
          event.stopPropagation();
          appHistory.pushState({}, "", "#filters");
          event.target.dispatchEvent(
            new Event("opensearchbar", { bubbles: true }),
          );
          trackOpenSearch(category?.en, listingType);
        }}
      >
        بحث
      </button>
      <div ref={categoriesListRef} className={css.list}>
        <AppLink
          onClick={(event) => {
            if (DEFAULT_CATEGORY.id === category?.id) return;
            trackCategoryChange(listingType, "all", "nav");
            if (listing)
              return updateContext({
                category: DEFAULT_CATEGORY,
                listing: null,
                page: 0,
                filters: {},
                city: null,
                direction: null,
                district: null,
              });
            updateContext({
              category: DEFAULT_CATEGORY,
              listing: null,
              page: 0,
              filters: {},
            });
          }}
          id={0}
          className={category?.id ? undefined : css.active}
          path={`${isDaily ? "/الحجز-اليومي" : ""}${DEFAULT_CATEGORY.path}`}
        >
          الكل
        </AppLink>
        {categories?.map((cat, i) => (
          <AppLink
            onClick={(event) => {
              trackCategoryChange(listingType, cat.en, "nav");
              if (listing)
                return updateContext({
                  category: cat,
                  listing: null,
                  page: 0,
                  filters: {},
                  city: null,
                  direction: null,
                  district: null,
                });
              updateContext({
                category: cat,
                listing: null,
                page: 0,
                filters: {},
              });
            }}
            id={cat.id}
            className={category?.path === cat.path ? css.active : undefined}
            key={cat.id}
            passHref
            path={`${isDaily ? "/الحجز-اليومي" : ""}${cat.path}`}
          >
            {cat.plural}
          </AppLink>
        ))}
      </div>
    </div>
  );
}
